import React, { useState } from "react";
import {
  ArrowRight,
  Heart,
  Menu,
  Search,
  ShoppingBag,
  UserRound,
  X,
} from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import { useWishlist } from "../contexts/WishlistContext";
import { getProfileImage } from "../core/api.jsx";
import storeLogo from "../assets/images/logo.png";

export default function Header({ onLogin }) {
  const [query, setQuery] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const profileImage = isAuthenticated ? getProfileImage(user) : "";
  const { cartCount } = useCart();
  const { wishlistIds } = useWishlist();
  const submitSearch = (event) => {
    event.preventDefault();
    navigate(
      `/shop${query.trim() ? `?keyword=${encodeURIComponent(query.trim())}` : ""}`,
    );
    setMobileOpen(false);
  };

  const links = [
    ["Home", "/"],
    ["Categories", "/categories"],
    ["Shop All", "/shop"],
    ["About Us", "/about"],
    ["Contact Us", "/contact"],
  ];

  return (
    <>
      <div className="announcement-bar">
        <span>
          ⚡ <strong>FREE EXPRESS DELIVERY</strong> on orders above ₹499
        </span>
        <span className="announcement-bar__right">
          100% Verified Quality · Easy 7-Day Returns <span>✦</span>
        </span>
      </div>
      <header className="site-header">
        <div className="site-header__inner page-shell">
          <button
            className="icon-button mobile-menu-button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            onClick={() => setMobileOpen((open) => !open)}
          >
            {mobileOpen ? <X /> : <Menu />}
          </button>
          <Link className="brand" to="/" aria-label="Sugam Store home">
            <img src={storeLogo} alt="Sugam Store" />
            <span>
              <strong>Sugam Store</strong>
              <small>Everyday Essentials</small>
            </span>
          </Link>
          <nav
            className={`main-nav${mobileOpen ? " main-nav--open" : ""}`}
            aria-label="Main navigation"
          >
            {links.map(([label, href]) =>
              href.includes("#") ? (
                <a key={label} href={href} onClick={() => setMobileOpen(false)}>
                  {label}
                </a>
              ) : (
                <NavLink
                  key={label}
                  to={href}
                  onClick={() => setMobileOpen(false)}
                >
                  {label}
                </NavLink>
              ),
            )}
            <form className="mobile-search" onSubmit={submitSearch}>
              <input
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Search products, brands and essentials..."
                aria-label="Search products"
              />
              <button aria-label="Search">
                <Search size={18} />
              </button>
            </form>
          </nav>
          <form className="header-search" onSubmit={submitSearch}>
            <Search size={18} />
            <input
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Search products, brands..."
              aria-label="Search products"
            />
            <button aria-label="Submit search">
              <ArrowRight size={16} />
            </button>
          </form>
          <div className="header-actions">
            <button
              className="header-action account-action"
              onClick={isAuthenticated ? () => navigate("/profile") : onLogin}
              aria-label={isAuthenticated ? "Your profile" : "Sign in"}
            >
              {isAuthenticated ? (
                <span className="account-avatar" aria-hidden="true">
                  <UserRound size={18} />
                  {profileImage && (
                    <img
                      src={profileImage}
                      alt=""
                      onError={(event) => event.currentTarget.remove()}
                    />
                  )}
                </span>
              ) : (
                <UserRound size={20} />
              )}
              {!isAuthenticated ? <span>Sign in</span> : ""}
            </button>
            <Link
              className="header-action saved-action"
              to="/wishlist"
              aria-label="Wishlist"
            >
              <Heart size={25} />
              <span className="header-action__count">{wishlistIds.length}</span>
            </Link>
            <Link
              className="header-action bag-action"
              to="/cart"
              aria-label={`Shopping bag, ${cartCount} items`}
            >
              <ShoppingBag size={25} />
              <span className="header-action__count">{cartCount}</span>
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}
